import { BrowserModule } from '@angular/platform-browser';
import { NgModule, isDevMode } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PreloaderComponent } from './components/common/preloader/preloader.component';
import { HomePageTwoComponent } from './components/pages/home-page-two/home-page-two.component';
import { FooterStyleOneComponent } from './components/common/footer-style-one/footer-style-one.component';
import { NavbarStyleOneComponent } from './components/common/navbar-style-one/navbar-style-one.component';
import { FooterStyleTwoComponent } from './components/common/footer-style-two/footer-style-two.component';
import { AboutComponent } from './components/pages/about/about.component';
import { PricingComponent } from './components/pages/pricing/pricing.component';
import { FaqComponent } from './components/pages/faq/faq.component';
import { DesignerComponent } from './components/pages/designer/designer.component';
import { TestimonialsComponent } from './components/pages/testimonials/testimonials.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { SignInComponent } from './components/pages/sign-in/sign-in.component';
import { SignUpComponent } from './components/pages/sign-up/sign-up.component';
import { RecoverPasswordComponent } from './components/pages/recover-password/recover-password.component';
import { TermsConditionsComponent } from './components/pages/terms-conditions/terms-conditions.component';
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';
import { ComingSoonComponent } from './components/pages/coming-soon/coming-soon.component';
import { ServicesComponent } from './components/pages/services/services.component';
import { ServicesDetailsComponent } from './components/pages/services-details/services-details.component';
import { ProductsComponent } from './components/pages/products/products.component';
import { CartComponent } from './components/pages/cart/cart.component';
import { CheckoutComponent } from './components/pages/checkout/checkout.component';
import { ProductsDetailsComponent } from './components/pages/products-details/products-details.component';
import { BlogComponent } from './components/pages/blog/blog.component';
import { BlogDetailsComponent } from './components/pages/blog-details/blog-details.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { OrderOnlineComponent } from './components/pages/order-online/order-online.component';
import { OrderAppsComponent } from './components/pages/order-apps/order-apps.component';
import { MenuComponent } from './components/pages/menu/menu.component';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { OrderSuccessComponent } from './components/pages/order-success/order-success.component';
import { AccountComponent } from './components/pages/account/account.component';
import { OrderDetailsComponent } from './components/pages/order-details/order-details.component';
import { WishlistComponent } from './components/pages/wishlist/wishlist.component';
import { AlertService } from './components/services/Alert/alert.service';
import { AlertComponent } from './components/common/alert/alert.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { environment } from 'src/environments/environment';
import { StripeModule } from "stripe-angular";
import { NotificationComponent } from './components/common/notification/notification.component';
import { OffersComponent } from './components/pages/offers/offers.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CustomFoodComponent } from './components/pages/custom-food/custom-food.component';
import { FailedOrderComponent } from './components/pages/failed-order/failed-order.component';


@NgModule({
  declarations: [
    AppComponent,
    PreloaderComponent,
    HomePageTwoComponent,
    FooterStyleOneComponent,
    NavbarStyleOneComponent,
    FooterStyleTwoComponent,
    AboutComponent,
    PricingComponent,
    FaqComponent,
    DesignerComponent,
    TestimonialsComponent,
    ErrorComponent,
    SignInComponent,
    SignUpComponent,
    RecoverPasswordComponent,
    TermsConditionsComponent,
    PrivacyPolicyComponent,
    ComingSoonComponent,
    ServicesComponent,
    ServicesDetailsComponent,
    ProductsComponent,
    CartComponent,
    CheckoutComponent,
    ProductsDetailsComponent,
    BlogComponent,
    BlogDetailsComponent,
    ContactComponent,
    OrderOnlineComponent,
    OrderAppsComponent,
    MenuComponent,
    OrderSuccessComponent,
    AccountComponent,
    OrderDetailsComponent,
    WishlistComponent,
    AlertComponent,
    NotificationComponent,
    OffersComponent,
    CustomFoodComponent,
    FailedOrderComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,

    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    // provideFirestore(() => getFirestore()),
    // provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    AngularFireDatabaseModule,
    AngularFireMessagingModule,
    StripeModule.forRoot("...YOUR-STRIPE-KEY-HERE..."),
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    AlertService,
    provideFirestore(() => getFirestore()),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig))
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
